import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ConfigurationService } from "../../services/configuration.service";
import { IAppStore } from "../../iappstore";
import { Store } from "@ngrx/store";
import { ClearUserDetailsAction } from "../../actions/applicationuser.action";
import { SetTokenAction } from "../../actions/azureauthentication.action";
import { IAzureAuthentication } from "../../interfaces/iazureauthentication";

@Component({
    selector: "logon",
    templateUrl: "./login.component.html",
    standalone: true,
    imports: [CommonModule]
})
export class LoginComponent implements OnInit {
    constructor(private configurationService: ConfigurationService, private readonly store: Store<IAppStore>) {
        this.store.dispatch(new ClearUserDetailsAction());
        this.store.dispatch(new SetTokenAction({ token: null } as IAzureAuthentication));
    }

    /**
     * Clears the selected user and business function
     * Initialises the login form
     */
    ngOnInit(): void {
        this.configurationService.getLoginUrl().subscribe((url: string) => {
            window.location.href = url;
        });
    }
}
